'use strict';

bbw.directive.bbwLocationInput = [function() {

    return {
        require: 'ngModel',
        scope: {
            'addClass': '@',
            'autodetect': '<',
            'defaultList': '<',
            'cityOnly': '<',
            'placeholder': '<',
            'mobileTitle': '<',
            'limit': '<'
        },
        template: '<bbw-location-picker add-class="addClass" mobile-title="mobileTitle" placeholder="placeholder" autodetect="autodetect" default-value="defaultValue" default-choice="defaultChoice" default-list="defaultList" city-only="cityOnly" limit="limit" on-update="updateValue(value)"></bbw-location-picker>',
        link: function(scope, element, attrs, ngModelController) {
            scope.defaultValue = ngModelController.$viewValue;
            if (scope.defaultValue) {
                scope.defaultChoice = ngModelController.$viewValue;
            }
            var initial = true;
            ngModelController.$setPristine();
            ngModelController.$render = function () {
                scope.defaultValue = ngModelController.$viewValue;
                if (initial) {
                    initial = false;
                    ngModelController.$setPristine();
                    ngModelController.$setUntouched();
                }
            };
            var locationsAreEqual = function(a, b) {
                if (angular.isObject(a) && angular.isObject(b)) {
                    if (a.type !== b.type) {
                        return false;
                    }
                    var k = '' + a.type + '_id';
                    return a[k] == b[k];
                }
                return false;
            };
            scope.updateValue = function(value) {
                if (locationsAreEqual(value, ngModelController.$viewValue)) {
                    return;
                }
                ngModelController.$render(value);
                ngModelController.$setViewValue(value);
                ngModelController.$setDirty();
            };
        }
    };

}];
